/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  ISignInUserMethods,
  SignInUserService,
  IURLMethods,
  URLService,
  IBrandMethods,
  // ICurrencyExchangeRateMethods,
  BrandService,
  // CurrencyExchangeRateService,
  MyProfileCardService,
  IMyProfileCardMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
} from "./components";

export type SignInPageAgent = ISignInUserMethods &
  IMyProfileCardMethods &
  IURLMethods &
  IStaticPageContentMethods &
  IBrandMethods;
// ICurrencyExchangeRateMethods;

const getPlugins = () => {
  return [
    new SignInUserService(),
    new MyProfileCardService(),
    new URLService(),
    new StaticPageContentService(),
    new BrandService,
    // new CurrencyExchangeRateService,
  ];
};

export const getAgent = () => {
  return createAgent<SignInPageAgent>({
    plugins: getPlugins(),
  });
};
